import React, {useEffect, useState} from 'react'
import styled, {keyframes} from 'styled-components'
// import {useLanguagesAPI, useLanguagesActions} from '../../features/getLangs'
// import {useCityAliasActions, useCityAliasAPI} from '../../features/getCityAlias'
// import classes from './Loading.module.css'
import Icon from '../../utils/Icon'

const Loading = ({background, color, width, height, size}) => {
  // const [fetchedLang, setFetchedLang] = useState(false)
  // const [cityOrGroup, setCityOrGroup] = useState(false)
  /**
   *  Get count value from Redux store. We defined selector
   *  (state => state.counter.value) inside counter feature folder,
   *  to make component global state agnostic
   */
  const rotate = keyframes`
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  `
  const LoadingContainer = styled.div`
    width: ${() => width || '100%'};
    height: ${() => height || '100vh'};
    left: 0;
    right: 0;
    z-index: 100;
    background: ${() => background || 'var(--brand-curent-bg)'};
    display: block;
    transition: opacity 0.5s ease-in-out;
    opacity: 1;
    position: absolute;
    .Main__Spinner {
      position: absolute;
      transform: translate(-50%, -50%);
      transition: opacity 0.3s ease-in-out;
      //opacity: 0;
      color: ${() => color || 'var(--brand-curent)'};
      top: calc(50% - ${() => size / 2 || 32}px);
      left: calc(50% - ${() => size / 2 || 32}px);
      opacity: 1;
      animation: ${rotate} 0.65s linear infinite;
    }
  `
  const loadingSize = size || '64'

  return (
    <LoadingContainer>
      <div className="LoadingWrapper">
        <Icon className={`icon-svg--size-${loadingSize} Main__Spinner`} name="SpinnerLoading--Static" />
      </div>
    </LoadingContainer>
  )
}

export default Loading
